<template>
  <el-dialog :title="title + stockType" visible="true">
    <el-form
      label-width="100px"
      :model="editForm"
      :rules="rules"
      ref="editForm"
    >
      <el-form-item label="型号" prop="model_type">
        <el-input
          size="small"
          v-model="editForm.model_type"
          auto-complete="off"
          placeholder="请输入型号"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="合格数量"
        prop="quality_number"
        v-if="stockType == '产品入库'"
      >
        <el-input
          size="small"
          v-model="editForm.quality_number"
          auto-complete="off"
          placeholder="请输入数量"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="不合格数量"
        prop="unquality_number"
        v-if="stockType == '产品入库'"
      >
        <el-input
          size="small"
          v-model="editForm.unquality_number"
          auto-complete="off"
          placeholder="请输入数量"
        ></el-input>
      </el-form-item>

      <el-form-item label="数量" prop="quantity" v-if="stockType == '基材入库'">
        <el-input
          size="small"
          v-model="editForm.quantity"
          auto-complete="off"
          placeholder="请输入生产数量"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="生产日期" prop="date">
        <el-date-picker v-model="editForm.date" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["stockType", "rowData"],
  data() {
    return {
      editForm: { unquality_number: 0 },
      title: "",
      rules: {
        model_type: {
          required: true,
          message: "请输入型号",
          trigger: "blur",
        },
        quality_number: {
       
          required: true,
          message: "请输入合格数量",
          trigger: "blur",
        },
        unquality_number: {
       
          required: true,
          message: "请输入不合格数量",
          trigger: "blur",
        },
        quanlity: {
       
          required: true,
          message: "请输入生产数量",
          trigger: "blur",
        },
      },
    };
  },
  created() {
    if (this.rowData.model_type) {
      console.log(this.rowData);
      this.title = "修改";
      this.editForm = {...this.rowData};
    } else {
      this.title = "增加";
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submitForm() {
      this.$refs.editForm.validate((res) => {
        if (res) {
          this.editForm.type="1"
          this.$emit("save", this.editForm);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/produceDataManage/pop/stockPop.vue